import React, { useEffect, useState } from 'react';
import { ChevronLeftIcon } from 'lucide-react';
export const IdScanFront = ({
  onBack,
  onNext
}) => {
  const [scanning, setScanning] = useState(true);
  const [scanned, setScanned] = useState(false);
  useEffect(() => {
    // Simulate scanning process
    if (scanning) {
      const timer = setTimeout(() => {
        setScanning(false);
        setScanned(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [scanning]);
  return <div className="flex flex-col p-6 flex-grow bg-white" data-id="element-213">
      <div className="flex items-center mb-6" data-id="element-214">
        <button onClick={onBack} className="mr-4" data-id="element-215">
          <ChevronLeftIcon size={24} data-id="element-216" />
        </button>
        <div className="flex-grow flex space-x-2" data-id="element-217">
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-218"></div>
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-219"></div>
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-220"></div>
          <div className="h-1 bg-gray-200 flex-grow rounded-full" data-id="element-221"></div>
        </div>
      </div>
      <h1 className="text-2xl font-bold mb-6 text-center" data-id="element-222">
        Place your ID vertically inside the frame
      </h1>
      <div className="flex justify-center mb-10" data-id="element-223">
        <div className="relative w-64 h-80" data-id="element-224">
          <div className="absolute inset-0 border-2 border-red-500 rounded-lg" data-id="element-225"></div>
          {scanning ? <div className="absolute inset-0 flex items-center justify-center" data-id="element-226">
              <div className="w-12 h-12 border-t-2 border-[#5c5cf5] rounded-full animate-spin" data-id="element-227"></div>
            </div> : <div className="absolute inset-0 flex items-center justify-center overflow-hidden rounded-lg" data-id="element-228">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wZBysmccNvU8zXysgqNTKF/Screenshot_2025-08-08_at_6.16.44_PM.png" alt="ID Front" className="w-full h-full object-cover" data-id="element-229" />
            </div>}
        </div>
      </div>
      <div className="flex justify-center mb-8" data-id="element-230">
        <div className="flex space-x-2" data-id="element-231">
          <div className="w-2 h-2 rounded-full bg-[#5c5cf5]" data-id="element-232"></div>
          <div className="w-2 h-2 rounded-full bg-gray-300" data-id="element-233"></div>
        </div>
      </div>
      <div className="mt-auto" data-id="element-234">
        <button className={`w-full py-3 rounded-full font-medium text-white ${scanned ? 'bg-[#4040f2]' : 'bg-gray-300'}`} onClick={onNext} disabled={!scanned} data-id="element-235">
          CONTINUE
        </button>
      </div>
    </div>;
};